import React, { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";

const StickyMobileCart = ({ price, onAdd, label = "Add to Cart" }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-gray-200 px-4 py-3 flex items-center gap-3 shadow-[0_-4px_12px_rgba(0,0,0,0.06)]"
      data-testid="sticky-mobile-cart"
    >
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-gray-400">Your price</div>
        <div className="font-semibold text-[#0a0a0a]">${Number(price).toFixed(2)}</div>
      </div>
      <button
        onClick={onAdd}
        className="flex-1 inline-flex items-center justify-center gap-2 bg-[#b91c1c] hover:bg-[#a01818] text-white h-12 text-[12px] font-semibold uppercase tracking-[0.18em] transition-colors"
      >
        <ShoppingCart className="h-4 w-4" /> {label}
      </button>
    </div>
  );
};

export default StickyMobileCart;
